export const Config = {
  ADMIN_IMAGE_URL: process.env.VUE_APP_IMAGE || "http://localhost:3333",
  CLIENT_IMAGE_URL:
    process.env.VUE_APP_CLIENT_IMAGE_URL || "http://localhost:3334",
  SWEEPSTAKES_LIFF_CLIENT_URL:
    process.env.VUE_APP_SWEEPSTAKES_LIFF_CLIENT_URL || "http://localhost:3000",

  //Donut graph color 30 colors
  GRAPH_COLOR: [
    "#00B14F",
    "#A9D08E",
    "#01B0F0",
    "#FF36FD",
    "#FFFF02",
    "#2F75B5",
    "#FFC001",
    "#FF0000",
    "#C65911",
    "#F3B084",
    "#FFD966",
    "#FFE698",
    "#8EA9DB",
    "#FF4E39",
    "#C9C9C9",
    "#757171",
    "#AEAAAA",
    "#FCE4D6",
    "#FFF2CC",
    "#DDEBF7",
    "#E2EFDA",
    "#C6E0B4",
    "#D0CECE"
  ]
};
